import { render } from "./RepairItemUpdate.vue?vue&type=template&id=22bbecbe&scoped=true"
import script from "./RepairItemUpdate.vue?vue&type=script&lang=js"
export * from "./RepairItemUpdate.vue?vue&type=script&lang=js"

import "./RepairItemUpdate.vue?vue&type=style&index=0&id=22bbecbe&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22bbecbe"]])

export default __exports__